// src/hooks/useAuthSession.js
import { useMemo } from "react";
import { getAuthSession } from "../utils/auth";

export default function useAuthSession() {
  return useMemo(() => getAuthSession(), []);
}